<template>
    <div
        class="border position-relative"
        :class="computedBorder"
        role="progressbar"
        :aria-valuenow="props.value"
        aria-valuemin="0"
        :aria-valuemax="props.maxValue"
    >
        <div
            class="progress-bar h-100 opacity-50 d-block"
            :class="computedClass"
            :style="{ width: `${computedWidth}%` }"
        >
            <div style="color: transparent">.</div>
        </div>
        <div class="progress-bar-text position-absolute top-0 w-100 text-center small pb-2">{{ props.value }} / {{ props.maxValue }}</div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    /**
     * The value to display.
     */
    value: number;

    maxValue: number;

    type?: 'success' | 'info' | 'warning' | 'danger' | 'dynamic' | 'dynamicinverse';
}>();

const computedWidth = computed(() => {
    if (props.maxValue === 0) {
        return 0;
    }
    return (props.value / props.maxValue) * 100;
});

const computedBorder = computed(() => {
    switch (props.type) {
        case 'success':
            return 'border-success';
        case 'info':
            return 'border-info';
        case 'warning':
            return 'border-warning';
        case 'danger':
            return 'border-danger';
        case 'dynamic':
            return computedWidth.value > 75
                ? 'border-success'
                : computedWidth.value > 50
                  ? 'border-info'
                  : computedWidth.value > 25
                    ? 'border-warning'
                    : 'border-danger';
        case 'dynamicinverse':
            return computedWidth.value > 75
                ? 'border-danger'
                : computedWidth.value > 50
                  ? 'border-warning'
                  : computedWidth.value > 25
                    ? 'border-info'
                    : 'border-success';
        default:
            return 'border-primary';
    }
});

const computedClass = computed(() => {
    switch (props.type) {
        case 'success':
            return 'bg-success';
        case 'info':
            return 'bg-info';
        case 'warning':
            return 'bg-warning';
        case 'danger':
            return 'bg-danger';
        case 'dynamic':
            return computedWidth.value > 75
                ? 'bg-success'
                : computedWidth.value > 50
                  ? 'bg-info'
                  : computedWidth.value > 25
                    ? 'bg-warning'
                    : 'bg-danger';
        case 'dynamicinverse':
            return computedWidth.value > 75
                ? 'bg-danger'
                : computedWidth.value > 50
                  ? 'bg-warning'
                  : computedWidth.value > 25
                    ? 'bg-info'
                    : 'bg-success';
        default:
            return 'bg-primary';
    }
});
</script>
